
import { Component, Prop, Vue } from 'vue-property-decorator';
import stores from '../../stores';
import { showToaster } from '@/components/DashboardComposer/helpers';

@Component
export default class AdminLostPassword extends Vue {
  email: string = '';
  error: boolean = false;
  errorMessage: string = '';
  admin = stores.admin;
  image = require('@/assets/images/profile-img.png');
  step: number = 1;

  mounted(){
  }
  onSubmit() {
    const response = stores.SuperAdmins.forgotPassword(this.email)
    response.then( (response : any)  => {
      if(response && response.responseCode === 200)
      {
        showToaster("success","",response.data)
        return
      }
      showToaster("danger","","Something went wrong!")
    }).catch(e => {
      showToaster("danger","","Something went wrong!")
    })
  }
  onImageLoadFailure(event: any) {
    event.target.src = require('../../../assets/nevron_logo.png');
  }
  get loginLink() {
    return '/admin/login'
  }
}
